import { render, staticRenderFns } from "./ui-textarea.component.vue?vue&type=template&id=28331cca&"
import script from "./ui-textarea.component.vue?vue&type=script&lang=ts&"
export * from "./ui-textarea.component.vue?vue&type=script&lang=ts&"
import style0 from "./ui-textarea.component.vue?vue&type=style&index=0&id=28331cca&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports